import { useEffect } from 'react'
import { useApolloClient } from 'react-apollo'

import { throttle } from 'lodash'

import {
  SESSION_REFRESH_QUEUED_SESSION_STORAGE_KEY,
  debouncedRefreshSessionCookies,
  isAuthenticated,
} from 'utils/auth'

// The wait time between session refreshes when user activity is detected.
// Note: This value should be equal to or less than the difference between
// SESSION_LENGTH and SESSION_ABOUT_TO_EXPIRE_WAIT_TIME defined in the
// SessionInactivityDetection component. Otherwise, there may be a period of time
// when the "Are You Still There?" modal is visible when the session has already expired.
export const SESSION_REFRESH_WAIT_TIME = 2 * 60 * 1000 // 2 minutes in milliseconds

export function SessionAutoRefresh() {
  const apolloClient = useApolloClient()

  useEffect(
    function startSessionAutoRefresh() {
      if (!apolloClient) {
        return
      }

      const callback = throttle(
        () => {
          if (!isAuthenticated()) {
            return
          }

          window.sessionStorage.setItem(SESSION_REFRESH_QUEUED_SESSION_STORAGE_KEY, 'true')
          debouncedRefreshSessionCookies(apolloClient)
        },
        SESSION_REFRESH_WAIT_TIME,
        {
          trailing: false, // don't invoke the function again after the throttle wait time
        },
      )

      const timeout = setTimeout(() => {
        window.document.addEventListener('mousemove', callback)
        window.document.addEventListener('touchstart', callback)
      }, SESSION_REFRESH_WAIT_TIME)

      return function cleanup() {
        clearTimeout(timeout)
        window.document.removeEventListener('mousemove', callback)
        window.document.removeEventListener('touchstart', callback)
      }
    },
    [apolloClient],
  )

  return null
}
